import getApi from '../../api'
import { SearchCodedInformationsResponse } from '../../model/CodedInformations'

export const searchCodedInformations = (search: string) =>
  getApi().get<SearchCodedInformationsResponse>('/coded_informations', { search })
